<template>
  <div class="nixtag-page">
    <main class="nixtag-container">
      <section class="nixtag-card">
        <div class="nixtag-card-tools hero-grid">
          <div class="nixtag-tools-left">
            <img
              class="nixtag-logo"
              src="https://espaco.blob.core.windows.net/nixtag-imagens/nixtag_logo.png"
              alt="Nixloc"
            />
            <div class="hero-meta">
              <span class="hero-chip">Atualizado em 2026</span>
            </div>
          </div>

          <div class="nixtag-tools-right">
            <div class="android-visual">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/d/d7/Android_robot.svg"
                alt="Android"
              />
            </div>
          </div>
        </div>

        <div class="nixtag-table-header">
          <div class="col-name">Arquivo</div>
          <div class="col-version">Versão</div>
          <div class="col-action"></div>
        </div>

        <div class="nixtag-row">
          <div class="col-name">
            <span class="file-pill">nixtag-app-android.apk</span>
          </div>

          <div class="col-version">
            <span class="version-pill">1.0.0</span>
          </div>

          <div class="col-action">
            <a
              class="download-link"
              href="https://espaco.blob.core.windows.net/nixtag-apk/com.nixweb.nixtag-Signed.apk"
              download="nixtag-app-android.apk"
            >
              Baixar APK
            </a>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: "Nixtag",
};
</script>

<style scoped>
.nixtag-page {
  min-height: 100vh;
  background: #f5f6f8;
  padding: 26px 16px;
}

.nixtag-container {
  max-width: 980px;
  margin: 0 auto;
}

.nixtag-card {
  background: #ffffff;
  border: 1px solid #e6e9ef;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(20, 28, 45, 0.04);
}

.nixtag-card-tools {
  padding: 22px 20px 16px;
}

.hero-grid {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 20px;
  align-items: center;
}

.nixtag-logo {
  width: 180px;
  height: auto;
  margin-bottom: 14px;
}

.nixtag-tools-left h1 {
  margin: 10px 0 8px;
  font-size: 32px;
  line-height: 1.1;
  color: #1f2937;
}

.nixtag-tools-left p {
  margin: 0;
  max-width: 560px;
  color: #6b7280;
  font-size: 15px;
  line-height: 1.5;
}

.hero-meta {
  margin-top: 14px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.hero-chip {
  background: #f3f4f6;
  color: #4b5563;
  border: 1px solid #e5e7eb;
  padding: 5px 11px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.nixtag-tools-right {
  display: flex;
  justify-content: center;
}

.android-visual {
  width: 80px;
  max-width: 100%;
  padding: 0;
}

.android-visual img {
  width: 100%;
  display: block;
}

.nixtag-table-header {
  display: flex;
  padding: 12px 20px;
  background: #f9fafb;
  border-top: 1px solid #eef0f3;
  border-bottom: 1px solid #eef0f3;
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
}

.nixtag-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid #f3f4f6;
}

.col-name {
  flex: 1;
}

.col-version {
  width: 130px;
}

.col-action {
  width: 130px;
  text-align: right;
}

.file-pill {
  background: #f3f4f6;
  color: #374151;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 13px;
}

.version-pill {
  background: #ecfdf5;
  color: #047857;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 600;
}

.download-link {
  display: inline-block;
  background: #16a34a;
  color: #ffffff;
  padding: 8px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s ease;
}

.download-link:hover {
  background: #15803d;
}

@media (max-width: 640px) {
  .nixtag-card-tools {
    padding: 18px 14px 12px;
  }

  .hero-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .nixtag-tools-left {
    text-align: center;
  }

  .nixtag-logo {
    margin: 0 auto 14px;
  }

  .nixtag-tools-left p {
    margin: 0 auto;
  }

  .hero-meta {
    justify-content: center;
  }

  .nixtag-tools-right {
    justify-content: center;
  }

  .android-visual {
    width: 108px;
  }

  .nixtag-tools-left h1 {
    font-size: 24px;
  }

  .nixtag-table-header {
    display: none;
  }

  .nixtag-row {
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 14px;
    text-align: center;
  }

  .col-name,
  .col-version,
  .col-action {
    width: 100%;
    text-align: center;
  }

  .download-link {
    width: 100%;
    max-width: 260px;
    margin: 0 auto;
    text-align: center;
  }
}
</style>
